import React, { Component } from "react";
import "./App.css";
import "typeface-roboto";
import "bootstrap/dist/css/bootstrap.css";
import ParentContainerComponent from "./ParentContainerComponent";
import MobileWeb from "./components/MobileWeb/MobileWeb";
import { socketUrl } from './constants';
import socketIoClient from "socket.io-client";

class App extends Component {
  constructor(props) {
    super(props);

    // Get user info from localStorage
    const id = window.localStorage.getItem("_id") || '';
    const roleId = window.localStorage.getItem("_roleId") || '';

    this.id = id;
    this.roleId = roleId;

    this.state = {
      socket: null,
      isMobile: window.innerWidth < 768,
      toggled: false // renamed from addClass for clarity
    };
  }

  componentDidMount() {
    // Initialize socket connection
    const socket = socketIoClient(socketUrl, {
      query: `u_id=${this.id}&role_id=${this.roleId}`
    });

    this.setState({ socket });

    // Add window resize listener
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  }

  toggleSidebar = () => {
    this.setState(prevState => ({ toggled: !prevState.toggled }));
  }

  render() {
    const { isMobile, socket, toggled } = this.state;
    const sidebarClass = toggled ? 'toggled' : '';

    return (
      <div className="App_new">
        <div id="sidebarWrap" className={sidebarClass}>
          {isMobile ? (
            <MobileWeb />
          ) : (
            <ParentContainerComponent socket={socket} />
          )}
        </div>
      </div>
    );
  }
}

export default App;
